/* eslint-disable prefer-rest-params */
/* eslint-disable func-names */
/* eslint linebreak-style: ["error", "windows"] */
/**
 * Sticky Header
 * @param   {object/string} opts
 * @return  {object/string}
 */
export default function (func, wait, immediate) {
  let timeout;
  return function () {
    const context = this;
    const args = arguments;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
